import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/fluxo-caixa')({
  component: lazyRouteComponent(
    () => import('@/features/fluxo-caixa/components/fluxo-caixa-page'),
    'FluxoCaixaPage'
  ),
})
